export function getVerticalBarInfo({
    data,
    x,
    y,
    xScale,
    yScale,
    group,
    groupData,
  }) {
    const yValue = y || 0;
    const [yDomainMin] = yScale.domain();

    return {
      x: xScale(x),
      y: yScale(yValue > 0 ? yValue : 0),
      width: xScale.bandwidth(),
      height: Math.abs(
        yScale(yValue) -
          (yValue > 0 ? yScale(Math.max(0, yDomainMin)) : yScale(0))
      ),
      value: y,
      data,
      group,
      groupData,
    };
  }